import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineTwitter,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Designed and Developed by Sourav Mohanty</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} SM</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/sourav8908/Mr.sourav"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <AiFillGithub />
              </a>
            </li>

            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/sourav89/"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedinIn />
              </a>
            </li>

            <li className="social-icons">
              <a
                href="https://x.com/SouravMohan98"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <AiOutlineTwitter />
              </a>
            </li>

            <li className="social-icons">
              <a
                href="https://www.hackerrank.com/profile/mohantysourav537"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
                title="HackerRank"
              >
                {/* Custom HackerRank SVG icon */}
                <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 50 50" fill="currentColor">
                  <g>
                    <polygon fill="#2EC866" points="25,2 47,13 47,37 25,48 3,37 3,13" />
                    <path fill="#fff" d="M34.2,32.7h-3.2l-2.7-4.7h-4.6v4.7h-3.1V17.3h8.2c3.1,0,5.1,1.7,5.1,4.6c0,2.1-1,3.5-2.8,4.2l3,5.2
                       C34.9,32.1,34.7,32.7,34.2,32.7z M29.2,22.2c1.4,0,2.1-0.6,2.1-1.8c0-1.2-0.7-1.8-2.1-1.8h-4.5v3.6H29.2z"/>
                  </g>
                </svg>
              </a>
            </li>

          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
